/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DangerousGoodsStackingRuleDto } from '../model';
// @ts-ignore
import type { UpdateDGStackingRuleDto } from '../model';
/**
 * DangerousGoodsStackingRulesApi - axios parameter creator
 */
export const DangerousGoodsStackingRulesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dangerousGoodsStackingRulesGetAll: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/DangerousGoodsStackingRules/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateDGStackingRuleDto} [updateDGStackingRuleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dangerousGoodsStackingRulesUpdatePrimaryImoClassStackingRule: async (updateDGStackingRuleDto?: UpdateDGStackingRuleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/DangerousGoodsStackingRules/UpdatePrimaryImoClassStackingRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDGStackingRuleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateDGStackingRuleDto} [updateDGStackingRuleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dangerousGoodsStackingRulesUpdateSecondaryImoClassStackingRule: async (updateDGStackingRuleDto?: UpdateDGStackingRuleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/DangerousGoodsStackingRules/UpdateSecondaryImoClassStackingRule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDGStackingRuleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DangerousGoodsStackingRulesApi - functional programming interface
 */
export const DangerousGoodsStackingRulesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DangerousGoodsStackingRulesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dangerousGoodsStackingRulesGetAll(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DangerousGoodsStackingRuleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dangerousGoodsStackingRulesGetAll(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DangerousGoodsStackingRulesApi.dangerousGoodsStackingRulesGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateDGStackingRuleDto} [updateDGStackingRuleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dangerousGoodsStackingRulesUpdatePrimaryImoClassStackingRule(updateDGStackingRuleDto?: UpdateDGStackingRuleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dangerousGoodsStackingRulesUpdatePrimaryImoClassStackingRule(updateDGStackingRuleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DangerousGoodsStackingRulesApi.dangerousGoodsStackingRulesUpdatePrimaryImoClassStackingRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {UpdateDGStackingRuleDto} [updateDGStackingRuleDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async dangerousGoodsStackingRulesUpdateSecondaryImoClassStackingRule(updateDGStackingRuleDto?: UpdateDGStackingRuleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.dangerousGoodsStackingRulesUpdateSecondaryImoClassStackingRule(updateDGStackingRuleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DangerousGoodsStackingRulesApi.dangerousGoodsStackingRulesUpdateSecondaryImoClassStackingRule']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DangerousGoodsStackingRulesApi - factory interface
 */
export const DangerousGoodsStackingRulesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DangerousGoodsStackingRulesApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dangerousGoodsStackingRulesGetAll(options?: RawAxiosRequestConfig): AxiosPromise<Array<DangerousGoodsStackingRuleDto>> {
            return localVarFp.dangerousGoodsStackingRulesGetAll(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DangerousGoodsStackingRulesApiDangerousGoodsStackingRulesUpdatePrimaryImoClassStackingRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dangerousGoodsStackingRulesUpdatePrimaryImoClassStackingRule(requestParameters: DangerousGoodsStackingRulesApiDangerousGoodsStackingRulesUpdatePrimaryImoClassStackingRuleRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.dangerousGoodsStackingRulesUpdatePrimaryImoClassStackingRule(requestParameters.updateDGStackingRuleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DangerousGoodsStackingRulesApiDangerousGoodsStackingRulesUpdateSecondaryImoClassStackingRuleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        dangerousGoodsStackingRulesUpdateSecondaryImoClassStackingRule(requestParameters: DangerousGoodsStackingRulesApiDangerousGoodsStackingRulesUpdateSecondaryImoClassStackingRuleRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.dangerousGoodsStackingRulesUpdateSecondaryImoClassStackingRule(requestParameters.updateDGStackingRuleDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for dangerousGoodsStackingRulesUpdatePrimaryImoClassStackingRule operation in DangerousGoodsStackingRulesApi.
 */
export interface DangerousGoodsStackingRulesApiDangerousGoodsStackingRulesUpdatePrimaryImoClassStackingRuleRequest {
    readonly updateDGStackingRuleDto?: UpdateDGStackingRuleDto
}

/**
 * Request parameters for dangerousGoodsStackingRulesUpdateSecondaryImoClassStackingRule operation in DangerousGoodsStackingRulesApi.
 */
export interface DangerousGoodsStackingRulesApiDangerousGoodsStackingRulesUpdateSecondaryImoClassStackingRuleRequest {
    readonly updateDGStackingRuleDto?: UpdateDGStackingRuleDto
}

/**
 * DangerousGoodsStackingRulesApi - object-oriented interface
 */
export class DangerousGoodsStackingRulesApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dangerousGoodsStackingRulesGetAll(options?: RawAxiosRequestConfig) {
        return DangerousGoodsStackingRulesApiFp(this.configuration).dangerousGoodsStackingRulesGetAll(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DangerousGoodsStackingRulesApiDangerousGoodsStackingRulesUpdatePrimaryImoClassStackingRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dangerousGoodsStackingRulesUpdatePrimaryImoClassStackingRule(requestParameters: DangerousGoodsStackingRulesApiDangerousGoodsStackingRulesUpdatePrimaryImoClassStackingRuleRequest = {}, options?: RawAxiosRequestConfig) {
        return DangerousGoodsStackingRulesApiFp(this.configuration).dangerousGoodsStackingRulesUpdatePrimaryImoClassStackingRule(requestParameters.updateDGStackingRuleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DangerousGoodsStackingRulesApiDangerousGoodsStackingRulesUpdateSecondaryImoClassStackingRuleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public dangerousGoodsStackingRulesUpdateSecondaryImoClassStackingRule(requestParameters: DangerousGoodsStackingRulesApiDangerousGoodsStackingRulesUpdateSecondaryImoClassStackingRuleRequest = {}, options?: RawAxiosRequestConfig) {
        return DangerousGoodsStackingRulesApiFp(this.configuration).dangerousGoodsStackingRulesUpdateSecondaryImoClassStackingRule(requestParameters.updateDGStackingRuleDto, options).then((request) => request(this.axios, this.basePath));
    }
}

